<template>
  <svg
    width="20"
    height="15"
    viewBox="0 0 20 15"
  >
    <path d="M0.75 13.0001H13.25C13.6642 13.0001 14 13.3358 14 13.7501C14 14.1298 13.7178 14.4435 13.3518 14.4932L13.25 14.5001H0.75C0.335786 14.5001 0 14.1643 0 13.7501C0 13.3704 0.282154 13.0566 0.648229 13.0069L0.75 13.0001H13.25H0.75ZM0.75 6.50006H19.25C19.6642 6.50006 20 6.83584 20 7.25006C20 7.62975 19.7178 7.94355 19.3518 7.99321L19.25 8.00006H0.75C0.335786 8.00006 0 7.66427 0 7.25006C0 6.87036 0.282154 6.55657 0.648229 6.5069L0.75 6.50006H19.25H0.75ZM0.75 0.0032959H16.25C16.6642 0.0032959 17 0.339082 17 0.753296C17 1.13299 16.7178 1.44679 16.3518 1.49645L16.25 1.5033H0.75C0.335786 1.5033 0 1.16751 0 0.753296C0 0.3736 0.282154 0.0598047 0.648229 0.0101423L0.75 0.0032959H16.25H0.75Z" />
  </svg>
</template>
